import { Space as AntSpace } from 'antd';
import { SpaceProps as AntSpaceProps } from 'antd/es/space';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';
import { Button } from 'components/atoms/button';
import { ButtonProps } from 'components/atoms/button/button';

interface SpaceProps extends AntSpaceProps {
  reverse?: boolean;
}

interface CallToActionProps extends SpaceProps {
  reverse?: boolean;
  okButtonProps?: ButtonProps;
  cancelButtonProps?: ButtonProps;
  okText?: string | React.ReactNode;
  cancelText?: string | React.ReactNode;
  onOk?: () => void;
  onCancel?: () => void;
}

const Space = styled(AntSpace)<SpaceProps>`
  ${ifProp(
    prop('reverse', false),
    css`
      flex-direction: row-reverse;
    `,
  )};
`;

export const CallToAction: FC<CallToActionProps> = ({
  className,
  reverse = false,
  okButtonProps,
  cancelButtonProps,
  okText,
  cancelText,
  onOk,
  onCancel,
  ...rest
}) => (
  <Space reverse={reverse} className={className} {...rest}>
    <Button {...cancelButtonProps} onClick={onCancel}>
      {cancelText || <FormattedMessage id="cancel" />}
    </Button>
    <Button type="primary" onClick={onOk} {...okButtonProps}>
      {okText || <FormattedMessage id="submit" />}
    </Button>
  </Space>
);
